////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////

class wgResourceCache {
    constructor(name) {
        this.name_ = name;
        this.resourceMap_ = new Map();
    }

    addResource(resource) {
        this.resourceMap_.set(resource.getName(), resource);
    }

    removeResource(resourceName) {
        this.resourceMap_.delete(resourceName);
    }

    findResourceByName(resourceName) {
        var res = this.resourceMap_.get(resourceName);
        if (res === undefined) {
            // not in the map
            return null;
        }
        return res;
    }

    // maybe convinience to find all textures or meshes?
}

export { wgResourceCache };
